import { Routes, Route } from "react-router-dom";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/pages/AdminDashboard";
import AdminBrands from "@/admin/pages/AdminBrands";
import AdminPages from "@/admin/pages/AdminPages";
import AdminBlog from "@/admin/pages/AdminBlog";
import AdminGallery from "@/admin/pages/AdminGallery";
import AdminTestimonials from "@/admin/pages/AdminTestimonials";
import AdminAppointments from "@/admin/pages/AdminAppointments";
import AdminNewsletter from "@/admin/pages/AdminNewsletter";
import AdminSettings from "@/admin/pages/AdminSettings";
import AdminAnalytics from "@/admin/pages/AdminAnalytics";
import AdminUsers from "@/admin/pages/AdminUsers";
import AdminRoles from "@/admin/pages/AdminRoles";
import AdminApprovals from "@/admin/pages/AdminApprovals";
import AdminAuditLog from "@/admin/pages/AdminAuditLog";

const AdminApp = () => (
  <AdminAuthProvider>
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="brands" element={<AdminBrands />} />
        <Route path="pages" element={<AdminPages />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="media" element={<AdminGallery title="Media Library" description="All uploaded media assets (currently backed by the Gallery collection)." />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="appointments" element={<AdminAppointments />} />
        <Route path="newsletter" element={<AdminNewsletter />} />
        <Route path="seo" element={<AdminPages />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="roles" element={<AdminRoles />} />
        <Route path="approvals" element={<AdminApprovals />} />
        <Route path="audit-log" element={<AdminAuditLog />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="" element={<AdminDashboard />} />
      </Route>
    </Routes>
  </AdminAuthProvider>
);

export default AdminApp;
